jQuery(function($){

    let $animationContainer = $('.join-us__animation-container');
    let $images = $animationContainer.find('.join-us__image');
    let $socials = $('.join-us__socials'); 

    // Als de animatiecontainer niet bestaat
    if ($animationContainer.length == 0 || $socials.length == 0 || $(window).width() < 1024) {
        return;
    }

    // Voor goede prestatie willen we alleen dat het scroll-event actief is wanneer de sectie daadwerkelijk in beeld is
    let intersectTrigger = document.querySelector('.join-us__animation-container');  

    function handleIntersect(entries, observer) {
        entries.forEach(entry => {       
            if (entry.isIntersecting) {
                $(window).on('scroll.images', function() {
                    let scrollTop = $(window).scrollTop();
                    let containerTop = $animationContainer.offset().top;
                    let containerHeight = $animationContainer.outerHeight();
                    let containerBottom = containerTop + containerHeight;
                    let windowHeight = $(window).height();
                    let imageHeight = $images.height();
                    
                    // Bepaal het punt waarop de animatie moet starten en stoppen
                    let startScroll = containerTop - windowHeight * 0.5; 
                    let endScroll = containerBottom - (imageHeight * 3) - 100; 

                    // Bereken de relatieve scrollvoortgang (van 0 tot 1)
                    let scrollProgress = Math.min(Math.max((scrollTop - startScroll) / (endScroll - startScroll), 0), 1);

                    // Gebruik de scrollvoortgang om elke afbeelding te animeren
                    $images.each(function(index) {
                        // Interpoleer posities op basis van de scrollvoortgang
                        let finalPosition = getFinalPosition(index);
                        let initialPosition = getInitialPosition(index);

                        let currentLeft = interpolate(initialPosition.left, finalPosition.left, scrollProgress);
                        let currentTop = interpolate(initialPosition.top, finalPosition.top, scrollProgress);
                        let currentScale = interpolate(initialPosition.scale, finalPosition.scale, scrollProgress);
                        let currentRotation = interpolate(initialPosition.rotation, finalPosition.rotation, scrollProgress);
                        
                        // Pas de transformatie toe op de afbeelding
                        $(this).css({
                            'left': currentLeft + 'px',
                            'top': currentTop + 'px',
                            'transform': 'translate(-50%, -50%) rotate(' + currentRotation + 'deg) scale(' + currentScale + ')'
                        });
                    });

                    // Animeer het socials-element om te schalen naar 1
                    let socialsScale = interpolate(0, 1, scrollProgress); 
                    $socials.css({
                        'transform': 'translate(-50%, -50%) scale(' + socialsScale + ')'
                    });

                });     
            } else {
                $(window).off('scroll.images');
            }
        });
    }

    // Functie om interpolatie te berekenen
    function interpolate(start, end, progress) {
        return start + (end - start) * progress;
    }

    // Startposities voor de afbeeldingen 
    function getInitialPosition(index) {
        let positions = [
            { left: -333, top: 100, scale: 0.7, rotation: -30 },
            { left: -222, top: 60, scale: 0.8, rotation: -20 },
            { left: -111, top: 30, scale: 0.9, rotation: -10 },
            { left: 0, top: 0, scale: 1, rotation: 0 },
            { left: 0, top: 0, scale: 1, rotation: 0 },
            { left: 111, top: 30, scale: 0.9, rotation: 10 },
            { left: 222, top: 60, scale: 0.8, rotation: 20 },
            { left: 333, top: 100, scale: 0.7, rotation: 30 }
        ];
        return positions[index];
    }

    // Eindposities voor de afbeeldingen 
    function getFinalPosition(index) {
        let positions = [
            { left: 291, top: 1000, scale: 1, rotation: 0 },      // Rechts van het midden
            { left: 291, top: 1533, scale: 1, rotation: 0 },      // Rechts van het midden
            { left: -291, top: 1533, scale: 1, rotation: 0 },     // Links van het midden
            { left: 0, top: 1000, scale: 1, rotation: 0 },        // Gecentreerd op de ouder
            { left: 0, top: 1533, scale: 1, rotation: 0 },        // Gecentreerd op de ouder
            { left: -291, top: 1000, scale: 1, rotation: 0 },     // Links van het midden
            { left: -291, top: 1266, scale: 1, rotation: 0 },     // Links van het midden
            { left: 291, top: 1266, scale: 1, rotation: 0 }       // Rechts van het midden
        ];
        return positions[index];
    }

    const observer = new IntersectionObserver(handleIntersect, {
        root: null, 
        threshold: 0.0 
    });

    observer.observe(intersectTrigger);
    
});
